import React from 'react';
import styled, { css } from 'styled-components';

// Components:
// @ts-ignore
import SearcherDropdown from '@lt/components/components/SearcherDropdown';
import TouristsPicker, { Style } from '@lt/components/components/TouristsPicker';
import DropdownIndicator from './components/DropdownIndicator';

import { TouristPicker } from './types';
import { leftBorder, MobileLabel } from '../../styles';
import { touristsPlaceholder } from './constants';

/**
 * Выбор туристов
 */
export const Picker = (props: TouristPicker) => {
  const { isWizard, isMobile, className, variant = 'default', ...otherProps } = props;

  return (
    <StyledTouristsPicker
      $isWizard={isWizard}
      $isMobile={isMobile}
      className={className}
      $variant={variant}
    >
      {isMobile && !isWizard && <MobileLabel $variant={variant}>{touristsPlaceholder}</MobileLabel>}
      <TouristsPicker
        {...otherProps}
        isMobile={isMobile}
        isMobileInput={isMobile}
        CustomDropdownIndicator={DropdownIndicator}
      />
    </StyledTouristsPicker>
  );
};

const StyledTouristsPicker = styled.div<{
  $isWizard: boolean;
  $isMobile?: boolean;
  $variant?: 'default' | 'hotel';
}>`
  ${({ $isMobile }) => !$isMobile && `max-width: 100px`};
  ${({ $isMobile, $isWizard }) =>
    $isMobile &&
    !$isWizard &&
    css`
      order: 1;
      display: flex;
      flex-direction: column;
      > * + * {
        margin-top: 4px;
      }
    `}

  width: 100%;
  margin-left: auto;
  position: relative;
  color: #17181a;
  min-width: 110px;

  ${Style.StyledLabel} {
    font-size: 14px;
  }

  ${({ $isMobile }) => !$isMobile && leftBorder}

  .react-select {
    &__control {
      height: 56px;
      padding: 8px;

      &--menu-is-open {
        ${Style.StyledLabel} {
          color: #17181a;
        }

        .react-select__indicators {
          transform: rotate(180deg);
        }
      }
    }

    &__menu {
      margin: 0;
      box-shadow: 0 2px 4px rgb(210 208 197 / 80%);
    }

    &__value-container {
      padding: 0;
    }
  }

  ${SearcherDropdown.Input} {
    border: ${({ $variant }) => ($variant === 'hotel' ? '1px solid #C2C5CC' : '1px solid black')};
    border-radius: 4px;
    box-shadow: none;

    ${({ $isMobile, $isWizard }) => $isMobile && !$isWizard && `height: 48px;`}

    &:hover {
      border: 0;
      box-shadow: none;
    }
  }

  ${({ $isWizard }) =>
    $isWizard &&
    css`
      max-width: 100%;
      padding: 0px 8px;
      order: 1;
      height: 100vh;
    `}
`;
